module.exports = __webpack_public_path__ + "img/351.77865cd7.png";